import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { TierRankGradient, type TierRank } from '@root/entities/tier-rank'

import { CurrencyIcon } from '../../ui/currency-icon'

import type { CurrencyModel } from '../../model'
import type { PairAddress } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type CurrencyCellProps = {
  currency: CurrencyModel
  iconSize?: number
  onClick?: React.MouseEventHandler<HTMLDivElement>
  tierRank: TierRank.TierRank | undefined
  pairAddress?: PairAddress
} & ClassNameProps

export const CurrencyCell: React.FC<CurrencyCellProps> = ({
  className,
  currency,
  iconSize = 28,
  tierRank,
  onClick,
  pairAddress,
}) => {
  return (
    <Root className={className} onClick={onClick} $clickable={Boolean(onClick)}>
      <CurrencyIcon
        size={iconSize}
        currency={currency}
        withNetwork
        auxIconSize={10}
        pairAddress={pairAddress}
      />
      <Ticker $tierRank={tierRank} ellipsis>
        {currency.ticker}
      </Ticker>
    </Root>
  )
}

const Root = styled.div<{ $clickable?: boolean }>`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 10px;

  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`

const Ticker = styled(Typography)<{
  $tierRank?: TierRank.TierRank | undefined
}>`
  color: var(--text-12);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  ${({ $tierRank }) =>
    $tierRank && TierRankGradient.tierRankTextGradientCss($tierRank)}
`
